
import React from 'react';
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { formatCurrency } from './utils';
import { ArrowRight } from "lucide-react";

interface ProjectDetailsStepProps {
  formData: {
    projectHours: string;
    complexityFactor: string;
    desiredHourlyRate: string;
  };
  onInputChange: (field: string, value: string) => void;
  onNext: () => void;
}

const ProjectDetailsStep: React.FC<ProjectDetailsStepProps> = ({
  formData,
  onInputChange,
  onNext,
}) => {
  const baseProjectFee = parseFloat(formData.projectHours) * parseFloat(formData.desiredHourlyRate) || 0;
  const adjustedProjectFee = baseProjectFee * parseFloat(formData.complexityFactor);

  const handleComplexityChange = (value: number[]) => {
    onInputChange('complexityFactor', value[0].toString());
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-2xl font-bold">Project Details</h3>
        <p className="text-muted-foreground">
          Tell us about your typical project scope
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="projectHours">Average Project Hours</Label>
          <Input
            id="projectHours"
            type="number"
            placeholder="Enter estimated hours per project"
            value={formData.projectHours}
            onChange={(e) => onInputChange('projectHours', e.target.value)}
          />
        </div>

        <div className="space-y-4">
          <Label>Project Complexity</Label>
          <Slider
            defaultValue={[1]}
            max={1.25}
            min={0.8}
            step={0.05}
            value={[parseFloat(formData.complexityFactor)]}
            onValueChange={handleComplexityChange}
          />
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>Simple (0.8x)</span>
            <span>Standard (1x)</span>
            <span>Complex (1.25x)</span>
          </div>
        </div>

        <div className="mt-6 p-4 bg-muted rounded-lg space-y-2">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Base Project Fee:</span>
            <span>{formatCurrency(baseProjectFee)}</span>
          </div>
          <div className="flex justify-between font-medium">
            <span>Adjusted Project Fee:</span>
            <span>{formatCurrency(adjustedProjectFee)}</span>
          </div>
        </div>

        <Button 
          onClick={onNext}
          className="w-full"
          disabled={!formData.projectHours}
        >
          Next Step
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ProjectDetailsStep;
